//@flow
import * as React from 'react'
import { connect } from 'react-redux';
import { reduxForm,formValueSelector,submit,change } from 'redux-form';
import MaterialPaperWrap from '../../components/common/MaterialPaperWrap'
import InvoiceHeaderForm from './InvoiceHeaderForm'
import ContainerRowActionDialog from '../../components/common/ContainerRowActionDialog'
import AthenaQualityReview from './AthenaQualityReview'
import { validate,getQualityReviewFormNoOfError } from './validate'

import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import collect from 'collect.js'
import type { InvoiceHeaderContainer$Props } from './flowTypes'

//Phoenix React Lib Components
import ContainerRowSpace from '@lesofi/phoenix-react-js/lib/ContainerRowSpace'
import ContainerRowError from '@lesofi/phoenix-react-js/lib/ContainerRowError'

import * as actions from '../../redux/athena/actions';

const InvoiceHeaderContainer=(props:InvoiceHeaderContainer$Props)=>{
    const formError = props.athena.formError
    const noOfErrorsInQualityReview = getQualityReviewFormNoOfError(props,collect(formError))
   
    return (
        <div className='row'>
            <div className='col-sm'>
                <MaterialPaperWrap>
                   <form onSubmit={props.handleSubmit} > 
                     <div className='container'>
                        <div className="row">
                            <div className="col-sm">
                                <div className="embed-responsive embed-responsive-1by1" style={{height: '100%'}}>
                                  <iframe className="embed-responsive-item" src={props.query.docUrl}></iframe>
                                </div>
                            </div>
                            <div className="col-sm">
                                <InvoiceHeaderForm 
                                jwt={props.query.jwt} isVerifyMode={props.query.isVerifyMode} 
                                taskAcceptedInfoId={props.query.taskAcceptedInfoId} 
                                {...props}
                                />
                            </div>
                        </div>
                        <ContainerRowError errorMsg={(props.athena.error:any)} />
                        <ContainerRowSpace />
                        <AthenaQualityReview demeter={props.athena} noOfErros={noOfErrorsInQualityReview} {...props}/>
                        <ContainerRowActionDialog 
                            title={'Invoice Data Extraction'}
                            message={'Please do double check and confirm all your inputs before click submit.'}
                            submitFunc={props.submitReduxForm}
                        />

                        <ContainerRowSpace />
                     </div>   
                  </form>   
                </MaterialPaperWrap>
            </div>
        </div>
    )    
}

const form='athenaInvoiceHeaderContainer'
const selector = formValueSelector(form)

const submitMethod = (values, dispatch, props) => {
    const { athena } = props;
    const { jwt,taskAcceptedInfoId } = props.query
    props.submitCloseActionDialog()
    props.invoiceSubmission(jwt,taskAcceptedInfoId,values,athena);
}

const InvoiceHeaderContainerReduxForm = reduxForm({
    form: form,
    enableReinitialize: true,
    validate,
    onSubmit: submitMethod
})(InvoiceHeaderContainer)

const mapStateToProps:any = (state, ownProps) => {
    return {
        athena: state.athena,
        initialValues: state.athena.formData,
        selector: selector,
        actConfDialog: state.actConfDialog
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      invoiceSubmission: (jwt,taskAcceptedInfoId,athenaResultset,athena) => {
        dispatch(actions.invoiceSubmission(jwt,taskAcceptedInfoId,athenaResultset,athena))  
      },
      submitOpenActionDialog: ()=> {
        dispatch(actConfDlgActions.openDialog())    
      },
      submitCloseActionDialog: ()=> {
        dispatch(actConfDlgActions.closeDialog())    
      },
      submitReduxForm: ()=>{
        dispatch(submit(form))
      },
      changeFieldValue: (field, value)=> {
        dispatch(change(form, field, value))
      },
      updateFormError: (error:any)=>{
        dispatch(actions.updateFormError(error))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderContainerReduxForm)


// WEBPACK FOOTER //
// ./src/views/projectAthena/InvoiceHeaderContainer.js